import { Col, Row } from 'antd';
import { Flex } from '../Flex';
import { Ripple } from '../Ripple';

export interface FoldingRowProps {
  open?: boolean;
  onClick: React.MouseEventHandler<HTMLOrSVGElement>;
  title: string | React.ReactElement;
  description: string | React.ReactElement;
}

export function FoldingRow({ onClick, open, title, description }: FoldingRowProps) {
  return (
    <Ripple onClick={onClick} className="bg-white px-2 py-3 shadow-sm">
      <Flex direction="column" className="activity-report-item">
        <Flex align="center">
          <Row className="w-full" align="middle">
            <Col span={13}>
              <b className="ps-3 text-base leading-none font-medium text-nowrap">{title}</b>
            </Col>
            <Col span={8}>
              <span className="flex ltr me-auto text-gray-500 text-base leading-none">
                {description}
              </span>
            </Col>
            <Col span={3}>
              <Flex justify="center">
                <i
                  style={{ borderColor: 'rgb(98,98,98)', borderRadius: '1px' }}
                  className={`ic-arrow ${open ? 'ic-arrow-up' : 'ic-arrow-down'} text-xs w-[8px] h-[8px]`} />
              </Flex>
            </Col>
          </Row>
        </Flex>
      </Flex>
    </Ripple>
  );
};

export default FoldingRow;
